import React, { useEffect, useState, useContext } from "react";
import jMoment from "moment-jalaali";
import Input from "../../shared/components/Input";
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_VALIDATED,
  VALIDATOR_AUTOCOMPLETE,
  VALIDATOR_DATE,
  VALIDATOR_SELECT,
} from "../../shared/util/validators";
import useForm from "../../shared/hooks/form-hooks";
import { useSelector, useDispatch } from "react-redux";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import { AuthContext } from "../../context/AuthContext";
import { CircularProgress } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import { useSnackbar } from "notistack";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import AdapterJalaali from "@date-io/jalaali";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import { baseUrl } from "../../baseUrl";
import { Checkbox, FormControlLabel } from "@mui/material";

const PredictionDate = (props) => {
  const orderId = props.orderId;
  const taskId = props?.process.taskId;
  const initialPrediction = props?.process.predictionDate;

  const auth = useContext(AuthContext);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);
  const [predictionDate, setPredictionDate] = useState(
    initialPrediction
      ? new Date(Number(initialPrediction))
      : jMoment().startOf("day")
  );

  const [wait, setWait] = useState(initialPrediction ? false : true);
  const waitHandler = (event) => {
    setWait(event.target.checked);
  };

  //request for date or wait change
  const changePredictionHandler = (event) => {
    event.preventDefault();
    setIsLoading(true);
    axios
      .put(
        "/api/v1/laboratorys/update-order-predictionDate",
        {
          orderId: orderId,
          taskId: taskId,
          predictionDate: wait ? null : new Date(predictionDate).getTime(),
        },

        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        enqueueSnackbar(response.data.message.message, { variant: "success" });
        setIsLoading(false);
      })
      .catch((e) => {
        const messages =
          e.response.data.data.length > 0
            ? e.response.data.data
            : e.response.data.message.message;
        setIsLoading(false);
        Array.isArray(messages)
          ? messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            })
          : enqueueSnackbar(messages, { variant: "error" });
      });
  };
  return (
    <>
      {" "}
      {isLoading ? (
        <CircularProgress color="inherit" />
      ) : (
        <>
          <Grid
            container
            spacing={2}
            sx={{ my: 2, py: 2, borderTop: 1, borderBottom: 1 }}
          >
            <Grid md={12} xs={12}>
              <Typography variant="h5" align="center" sx={{ mb: 2 }}>
                تغییر وضعیت
              </Typography>
            </Grid>
            <Grid md={4} xs={8}>
              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterJalaali}>
                  <DatePicker
                    value={predictionDate}
                    onChange={(date) => setPredictionDate(date)}
                    // disablePast={true}
                    label="پیش بینی خروج"
                    disableMaskedInput
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size={"medium"}
                        variant={"outlined"}
                        disabled={wait}
                      />
                    )}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid md={2} xs={4}>
              <FormControlLabel
                sx={{ justifyContent: "start" }}
                control={<Checkbox checked={wait} onChange={waitHandler} />}
                label="در انتظار"
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Button
                onClick={changePredictionHandler}
                disabled={predictionDate == null}
                fullWidth
                color="secondary"
                variant="contained"
              >
                اعمال تاریخ
              </Button>
            </Grid>
          </Grid>
          <hr />
        </>
      )}
    </>
  );
};

export default PredictionDate;
